import { BsPlayBtn } from 'react-icons/bs';
import { CreativeInfoItem } from '@blisspointmedia/bpm-types/dist/Creative';
import { Img } from '@Components/Img';
import { Video } from '@Components/Video';
import {
  getCreativeAsset,
  getCreativeThumbnail
} from '@Components/MetricsTable/metrics-table-utils';
import { TEST_COMPANY } from './creative-insights-constants';

interface CreativeMediaPlayerProps {
  cid: string;
  selectedCreative: CreativeInfoItem;
}

export const CreativeMediaPlayer = ({ cid, selectedCreative }: CreativeMediaPlayerProps) => {
  if (cid === TEST_COMPANY) {
    return (
      <Img className='video-container' src={getCreativeThumbnail(cid, selectedCreative.isci)} />
    );
  }

  return (
    <div className='video-container'>
      <Video
        src={getCreativeAsset(cid, selectedCreative.file)}
        poster={getCreativeThumbnail(cid, selectedCreative.isci)}
        className='video-player'
        unloader={<BsPlayBtn size={100} />}
      />
    </div>
  );
};
